module.exports = __webpack_public_path__ + "static/media/arushicopy.02f1dae8.png";